export { default as IconAngleLeftLine } from './angle-left-line.svg';
export { default as IconAngleRightLine } from './angle-right-line.svg';
